export const employmentSectorPageMap = {
  EmploymentDetailsPage: {
    path: "/employment/details",
  },
};
